import { httpService } from '../http/httpService';
import {
  LoginRequest,
  LoginResponse
} from '../../models/types';
import { environmentService } from '../config/environmentService';


class UserService {

  private get apiBaseUrl() {
    return environmentService.getConfig().apiBaseUrl;
  }

  async login(credentials: LoginRequest): Promise<LoginResponse> {
    try {
      const response = await httpService.post<LoginResponse>(
        `${this.apiBaseUrl}/api/Login/login`,
        {
          username: credentials.username,
          password: credentials.password
        }
      );

      return response;
    } catch (error: any) {
      if (error?.response?.data) {
        return error.response.data;
      }
      throw new Error('Login failed. Please try again.');
    }
  }

  async autoLogin(key: string): Promise<LoginResponse> {
    try {
      if (key) {
        const response = await httpService.post<LoginResponse>(
          `${this.apiBaseUrl}/api/Login/BySession?sessionKey=${key}`
        );
        return response;
      } else {
        throw new Error('Key not found.');
      }
    } catch (error: any) {
      if (error?.response?.data) {
        return error.response.data;
      }
      throw new Error('AutoLogin failed. Please try again.');
    }
  }

  async logout(): Promise<void> {
    // Clear local storage
    sessionStorage.removeItem('authToken');
    return Promise.resolve();
  }

}

export const userService = new UserService(); 